import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class LayoutService {
  // isCallOnGoing = true;

  private isCallOnGoingSource = new BehaviorSubject<boolean>(false);
  public isCallOnGoing = this.isCallOnGoingSource.asObservable();
}
